export const courses = [
    {
        name: "Python3: Deep Dive",
        platform: "Udemy",
        dates: "2024"
    },
    {
        name: "Rest API with Python & Django Advanced",
        platform: "Udemy",
        dates: "2023"
    },
    {
        name: "Practical Web Development with Docker, Django, Nginx, Redis",
        platform: "Udemy",
        dates: "2022"
    },
    {
        name: "Docker for beginners",
        platform: "Udemy",
        dates: "2022"
    },
    {
        name: "Build an E-commerce website with Django and React",
        platform: "Udemy",
        dates: "2021"
    },
    {
        name: "Web Scraping with Python",
        platform: "Udemy",
        dates: "2021"
    },
    {
        name: "Scientific Computing with Python Certification",
        platform: "freecodecamp.org",
        dates: "2021"
    },
    {
        name: "Python Mega Course: Build 10 Real World Application",
        platform: "Udemy",
        dates: "2020"
    },
]